<template>
  <div>
    <vx-card title-color="primary" class="fill">
      <div>
        <div class="row fill">
          <div class="col-md-4 shadow bg-white rounded overflow-y-scroll tree-panel">
            <div>
              <!-- skeleton loader -->
              <transition
                enter-active-class="animated fadeIn"
              >
                <div class="w-100" v-show="!Object.keys(getRepositories).length && loading">
                  <b-skeleton
                    class="bg-grey-light border-0 w-48 h-8 mb-3"
                    type="input"
                    animation="fade"
                  />
                  <b-skeleton
                    class="bg-grey-light border-0 w-32 h-8 mb-3"
                    type="input"
                    animation="fade"
                  />
                  <b-skeleton
                    class="bg-grey-light border-0 w-64 h-8 mb-3"
                    type="input"
                    animation="fade"
                  />
                  <div class="d-flex w-100">
                    <b-skeleton
                      class="bg-grey-light border-0 w-3 h-3 ml-3"
                      type="text"
                      animation="fade"
                    />
                    <b-skeleton
                      class="bg-grey-light border-0 w-3 h-3 ml-1"
                      type="text" animation="fade"
                    />
                    <b-skeleton
                      class="bg-grey-light border-0 w-3 h-3 ml-1"
                      type="text" animation="fade"
                    />
                  </div>
                </div>
              </transition>
              <div v-show="!Object.keys(getRepositories).length && !loading">
                <NewRepository />
              </div>
              <!-- treeview -->
              <div class="w-100" v-show="Object.keys(getRepositories).length">
                <transition-group
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                  <RepositoriesTree
                    v-for="repository in getRepositories" :key="repository.repositorioId"
                    class="item"
                    :repository="repository"
                  />
                </transition-group>
              </div>
              <span v-if="getRepositories.length <= 0">No tienes acceso a ningun repositorio.</span>
            </div>
          </div>
          <div id="main-panel" class="col-md-8">
            <b-overlay :show="loading">
              <!-- NAVEGADOR DE DIRECTORIOS Y DOCUMENTOS -->
              <NavigationPanel :toggle="toggle"/>
              <vs-divider/>
              <!-- PANEL DE DETALLES -->
              <DetailsPanel
                v-if="getSelectedElement" :detailItem="detailItem"
                v-on:toggleRepositoryViewPanel="toggleView()"
              />
            </b-overlay>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import RepositoriesTree from '@/febos/global/documentManagement/components/RepositoriesTree';
import NewRepository from '@/febos/global/documentManagement/components/NewRepository';
import DetailsPanel from '@/febos/global/documentManagement/components/DetailsPanel';
import NavigationPanel from '@/febos/global/documentManagement/components/NavigationPanel';

export default {
  components: {
    RepositoriesTree,
    DetailsPanel,
    NavigationPanel,
    NewRepository
  },
  data() {
    return {
      detailItem: {},
      toggle: false
    };
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getRepositories',
      'getSelectedElement',
      'loading'
    ])
  },
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('List', [
      'fetchUserGroups'
    ]),
    ...mapActions('DocManagement', [
      'loadRepositories',
      'cleanTreeView',
      'setSelectedRepository'
    ]),
    toggleView() {
      console.log('toggle from parent');
      this.toggle = !this.toggle;
    },
  },
  beforeMount() {
    this.cleanTreeView();
  },
  mounted() {
    if (window.location.hash !== '') {
      // TODO: mostrar mensaje de que estamos llendo en busqueda de tu archivo o carpeta
      this.$bvToast.toast(
        'Espera unos segundos mientras vamos hacia tu archivo o carpeta',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 15000
        }
      );
    }
    this.loadRepositories();
  },
  created() {
    this.closeModal();
    this.fetchUserGroups();
  }
};
</script>

<style lang="scss" scoped>
@import '~animate.css/animate.compat.css';
.fill {
  height: calc(var(--vh, 1vh) * 100 - 12.5rem);
}
.tree-panel {
  height: calc(var(--vh, 1vh) * 100 - 14.5rem);
}
</style>
